/**
 * Marketing Number Ticker
 *
 * Counts up when scrolled into view — Magic UI Number Ticker pattern.
 */

'use client'

import { useEffect, useRef } from 'react'
import { useInView, useMotionValue, useSpring } from 'motion/react'

import { cn } from '@/lib/utils'

export function MarketingNumberTicker({
  value,
  className,
  delay = 0
}: {
  value: number
  className?: string
  delay?: number
}) {
  const ref = useRef<HTMLSpanElement>(null)
  const inView = useInView(ref, { once: true, margin: '-40px' })
  const motionValue = useMotionValue(0)
  const spring = useSpring(motionValue, { stiffness: 90, damping: 28 })

  useEffect(() => {
    if (!inView) return
    const timer = window.setTimeout(() => motionValue.set(value), delay * 1000)
    return () => window.clearTimeout(timer)
  }, [delay, inView, motionValue, value])

  useEffect(() => {
    const unsubscribe = spring.on('change', latest => {
      if (ref.current) ref.current.textContent = String(Math.round(latest))
    })
    return unsubscribe
  }, [spring])

  return (
    <span ref={ref} className={cn('tabular-nums', className)}>
      0
    </span>
  )
}
